import { Form } from "@unform/web";

import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 40px;
  padding: 40px 0;
  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};

  color: ${({ theme }) => theme.colors.neutral.white};

  ${media.greaterThan("medium")`
    margin: 0 auto;
    padding: 20px 0;

    max-width: 950px;
  `};
`;

export const BannerArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 350px;

  h2 {
    font-size: 40px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }
`;

export const Header = styled(Form)`
  display: flex;
  width: 100%;
  gap: 5px;

  button {
    width: 30%;
  }

  ${media.lessThan("medium")`
    button {
      width: 100%;
    }
  `}
`;

export const Title = styled.h2`
  font-size: 40px;
  color: ${({ theme }) => theme.colors.primary.orange};
`;

export const Subtitle = styled.h3`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.neutral.white};
`;

export const Kpis = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 40px;
`;

export const Main = styled.div`
  width: 100%;

  background-color: ${({ theme }) => theme.colors.neutral.cinza900};

  padding: 40px;
`;

export const Projects = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 20px;

  ${media.lessThan("medium")`
    flex-direction: column;
    align-items: center;
    gap: 10px;
  `}
`;

export const Selectives = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
`;

export const SelectiveGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const SelectiveHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;

  padding-bottom: 10px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.primary.orange};

  h2 {
    font-size: 22px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.cinza200};
  }
`;

// Lado direito do cabeçalho da seletiva: período + download da apresentação.
export const SelectiveActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

// Mesmo botão de download da aba de arquivos do projeto: a área comum é ESCURA,
// então o rótulo é branco sobre laranja (não usar estilo de tela admin).
export const DownloadPresentation = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  height: 34px;
  padding: 0 14px;
  border-radius: 4px;
  cursor: pointer;

  background-color: ${({ theme }) => theme.colors.primary.orange};

  h1 {
    color: ${({ theme }) => theme.colors.neutral.white};
    font-size: 13px;
  }

  :hover {
    opacity: 0.8;
  }
`;

// Seletivas "Finalizada": ficam recolhidas abaixo das vigentes, para não competir
// com a seletiva "Enviado" (que é o foco do patrocinador).
export const HistoryBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
`;

export const HistoryToggle = styled.button`
  align-self: flex-start;

  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.neutral.cinza600};
  border-radius: 20px;
  padding: 8px 18px;

  color: ${({ theme }) => theme.colors.neutral.cinza200};
  font-size: 14px;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary.orange};
    color: ${({ theme }) => theme.colors.neutral.white};
  }
`;

export const Columns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-content: center;
  align-items: center;
  padding: 15px 20px;
  text-align: center;
`;

export const EmptyBg = styled.div`
  width: 100%;
  height: 100px;
  background-color: ${({ theme }) => theme.colors.neutral.cinza600};
`;

export const Project = styled.div`
  display: flex;
  flex-direction: column;

  cursor: pointer;

  background-color: ${({ theme }) => theme.colors.neutral.cinza800};
  width: 270px;

  img {
    width: 100%;
    object-fit: cover;

    height: 100px;
  }
`;

export const ProjectInfos = styled.div`
  display: flex;
  flex-direction: column;

  gap: 10px;

  padding: 15px;

  h1 {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.neutral.white};
    height: 50px;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.cinza200};
    max-width: 150px;
  }
`;
